import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { orderConfirmationPageTrace } from './order-confirmation-models/order-confirmation-page-load.trace';
import { ORDER_CONFIRMATION_TRACING_ACTIONS } from './order-confirmation-tracing.actions';
import { pageLoadTraceTransformer } from './order-confirmation-tracing.transformers';
import { OrderHeader } from '@usf/ngrx-order';
import { genericTracingTransformer } from '@shared/tracking/tracing/generic-tracing-transformer';
import { OrderConfirmationTracingMessages } from './order-confirmation-tracing.constants';
import { FileEntity } from '@shared/models/file-entity';
import { Order } from '@usf/ngrx-order';
import { ORDER_TRACING_ACTIONS } from '@order/tracking/tracing/order-tracing.actions';

@Injectable({
  providedIn: 'root',
})
export class OrderConfirmationTracingService {
  constructor(private store: Store) {}

  tracePageLoad(id: string, totalAmount: number): void {
    const tracking: Tracking = JSON.parse(
      JSON.stringify(orderConfirmationPageTrace),
    );
    tracking.tracing.data.attributes.orderId = id;
    tracking.tracing.data.attributes.totalAmount = totalAmount;
    tracking.tracing.transformFunc = pageLoadTraceTransformer;
    this.store.dispatch(
      ORDER_CONFIRMATION_TRACING_ACTIONS.tracePageLoad({ tracking }),
    );
  }

  traceConfirmationOrderDownload = (
    orderHeader: OrderHeader,
    fileEntity: FileEntity,
  ) => {
    const {
      orderId,
      origSplitOrderId,
      origOrderId,
      requestedDeliveryDate,
      confirmedDeliveryDate,
      tandemOrderNumber,
      totalDollars,
    } = orderHeader;

    const tracking: Tracking = {
      tracing: {
        data: {
          traceContext: OrderConfirmationTracingMessages.capability,
          isEndOfTrace: true,
          isStartOfTrace: true,
          attributes: {
            order: {
              orderId,
              origSplitOrderId: !!origSplitOrderId ? origSplitOrderId : '',
              origOrderId: !!origOrderId ? origOrderId : '',
              totalAmount: totalDollars,
              requestedDeliveryDate,
              confirmedDeliveryDate,
              tandemOrderNumber: !!tandemOrderNumber ? tandemOrderNumber : '',
              fileFormat: fileEntity.fileExtension,
            },
            event: OrderConfirmationTracingMessages.downloadOrder,
          },
        },
        transformFunc: genericTracingTransformer,
      },
    };
    this.store.dispatch(
      ORDER_CONFIRMATION_TRACING_ACTIONS.downloadOrder({ tracking }),
    );
  };

  endOrderSubmissionTrace(order: Order, isWebsocket: boolean) {
    this.store.dispatch(
      ORDER_TRACING_ACTIONS.endOrderSubmissionTrace({
        order,
        isWebsocket,
      }),
    );
  }
  endVptOrderSubmissionTrace(order: Order, isWebsocket: boolean) {
    this.store.dispatch(
      ORDER_TRACING_ACTIONS.endVptOrderSubmissionTrace({
        order,
        isWebsocket,
      }),
    );
  }
}
